import { ModelUser } from '@module-user/models/model-user';
import { Observable } from 'rxjs';
import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { CurrentUserService } from '@services/current-user/current-user.service';
import { Store, Select } from '@ngxs/store';
import { ActionAsideMenuOpenClose } from '@global-actions/action-aside-menu/action-aside-menu';
import { AuthenticationService } from '@services/authentication/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderComponent implements OnInit {
  showSideMenu = true;
  currentUser$!: Observable<ModelUser>;
  @Select('stateAsideMenu') isMenuOpen!: Observable<ActionAsideMenuOpenClose>;
  constructor(
    private _currentUser: CurrentUserService,
    private _store: Store,
    private auth: AuthenticationService
  ) {}
  ngOnInit(): void {
    this.currentUser$ = this._currentUser.currentUser$;
    this._store.dispatch(new ActionAsideMenuOpenClose(true));
  }

  toggleMenu(e: any): void {
    this._store.dispatch(
      new ActionAsideMenuOpenClose((this.showSideMenu = !this.showSideMenu))
    );
    e.stopPropagation();
  }

  logout(): void {
    this.auth.logout();
  }
}
